import { DeliveriesDataGridApi } from "src/api/generated/erp/delivery/api/deliveriesDataGridApi.ts";
import { CustomerOrderDeliveriesDataGrid } from "src/components/views/erp/sales/delivery/CustomerOrderDeliveriesDataGrid.tsx";

export interface CustomerDeliveriesDataGridProps {
	customerId: number;
}

export const CustomerDeliveriesDataGrid = ({ customerId }: CustomerDeliveriesDataGridProps) => (
	<CustomerOrderDeliveriesDataGrid
		fetchData={(params) =>
			DeliveriesDataGridApi.getDeliveriesForCustomer({
				...params,
				customerId,
			})
		}
	/>
);
